export const groupedDropdownCustomStyling = {
    control: (provided) => ({
        ...provided,
        minWidth: '200px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#393e5c' : state.isFocused ? '#f8f9fa' : 'transparent',
        color: state.isSelected ? 'white' : 'inherit',
        paddingLeft: state.data.group ? '20px' : '40px'
    }),
    groupHeading: (provided) => ({
        ...provided,
        fontWeight: 'bold',
        textTransform: 'capitalize',
        color: '#495057',
        fontSize: '14px',
        padding: '8px 12px',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #dee2e6'
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#6c757d'
    })
}

export const groupedHeaderDropdownCustomStyling = {
    control: (provided) => ({
        ...provided,
        minWidth: '200px',
        border: 'None',
        backgroundColor: 'transparent',
        color: "black",
        fontWeight: "500",
        fontSize: "15px",
        boxShadow: "None"
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#393e5c' : state.isFocused ? '#f8f9fa' : 'transparent',
        color: state.isSelected ? 'white' : 'inherit',
        paddingLeft: state.data.group ? '20px' : '40px'
    }),
    groupHeading: (provided) => ({
        ...provided,
        fontWeight: 'bold',
        textTransform: 'capitalize',
        color: '#495057',
        fontSize: '14px',
        padding: '8px 12px',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #dee2e6'
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#6c757d'
    })
}

export const getHeaderDropdownCustomStyling = (width = '200px') => ({
    control: (provided) => ({
        ...provided,
        minWidth: width,
        border: 'None',
        backgroundColor: 'transparent',
        color: "black",
        fontWeight: "500",
        fontSize: "15px",
        boxShadow: "None"
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#393e5c' : state.isFocused ? '#f8f9fa' : 'transparent',
        color: state.isSelected ? 'white' : 'inherit',
        // paddingLeft: state.data.group ? '20px' : '40px'
    }),
    groupHeading: (provided) => ({
        ...provided,
        fontWeight: 'bold',
        textTransform: 'capitalize',
        color: '#495057',
        fontSize: '14px',
        padding: '8px 12px',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #dee2e6'
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#6c757d'
    })
});